import { Container, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { MobileAppDownloadCta } from '@app/components/MobileAppDownloadCta'
import { useAuth } from '@app/context/auth'

export const MobileAppPanel = () => {
  const { t } = useTranslation('pages', { keyPrefix: 'welcome' })

  const { activeCertificates } = useAuth()

  const isCertified = Number(activeCertificates?.length) > 0

  return (
    <Container>
      <Grid
        display={'flex'}
        alignItems={'center'}
        mb={5}
        mt={isCertified ? 8 : 0}
        gap={2}
        container
        maxWidth={'432px'}
        justifySelf={'center'}
      >
        <Grid item flex={2}>
          <Typography
            fontWeight={500}
            color="primary"
            fontFamily="Poppins"
            variant="h1"
            sx={{ fontSize: { xs: '25px', md: '28px' } }}
          >
            {t('mobile-app-panel.title')}
          </Typography>
          <Typography mt={1} lineHeight={1.5} variant="h4">
            {t('mobile-app-panel.description')}
          </Typography>
        </Grid>
        <MobileAppDownloadCta />
      </Grid>
    </Container>
  )
}
